import { Component, Input, OnInit, HostListener } from '@angular/core'
import { MasterKey } from '../../models/master-key'
import { MasterKeyService } from '../../services/master-key.service'

@Component({
    selector: 'lib-key',
    templateUrl: './key.component.html',
    styleUrls: ['./key.component.scss'],
    standalone: false
})
export class KeyComponent implements OnInit {
  @Input() hierarchyItem: MasterKey
  @Input() selectedMasterKey: MasterKey
  @Input() showChangeKeys = false
  @Input() limitSize = false
  @Input() disabled = false
  @Input() canMinimize = false

  constructor(private masterKeyService: MasterKeyService) {}

  /**
   * Double-click handler for quick key assignment.
   * Emits the key to MasterKeyService which is subscribed to by hierarchy.component.
   * This uses service-based communication instead of @Output because lib-master-key-tree
   * is recursive, making event propagation unreliable through the component tree.
   * See: docs/features/DOUBLE_CLICK_KEY_ASSIGNMENT.md for details.
   */
  @HostListener('dblclick', ['$event'])
  onDoubleClick(event: MouseEvent) {
    event.stopPropagation()
    this.masterKeyService.emitAssignKey(this.hierarchyItem)
  }

  ngOnInit() {}

  replace(item) {
    if (item.includes('-')) {
      return item.replace('-CHGS-', '')
    }
    return item
  }

  toggleMinimized() {
    //if TMK is minimized, minimize all direct children
    if(this.hierarchyItem.distanceFromTMK === 0) {
      if(this.hierarchyItem.children.filter((child) => child.isMinimized).length > 0) {
        this.hierarchyItem.showMinimizedIcon = false
        this.hierarchyItem.children.forEach(child => {
          child.isMinimized = false
        })
      } else {
        this.hierarchyItem.showMinimizedIcon = true
        this.hierarchyItem.children.forEach(child => {
          child.isMinimized = true
        })
      }
    } else {
      this.hierarchyItem.isMinimized = !this.hierarchyItem.isMinimized
    }
  }

  hasMinimize(hierarchyItem) {
    if (
      this.canMinimize &&
      hierarchyItem?.children?.length &&
      !hierarchyItem.isChangeKey &&
      (hierarchyItem.children.length !== hierarchyItem.changeKeys.length || this.showChangeKeys)
    ) {
      return true
    } else {
      return false
    }
  }
}
